'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const MemberModel = require('common/domain/entity/member');

module.exports = Backbone.Collection.extend({
    /**
     * Backbone.Collection を extend した MemberCollection を定義する
     */
    model: MemberModel,

    comparator: function(member) {
        return `${member.isSuspended() ? 1 : 0}:${member.getRole()}:${member.getUser().getName().toLowerCase()}`;
    },

    /**
     * User オブジェクトまたは User.id を引数にとり、
     * 該当する Member がいればその member を返す。
     * null が入力された場合は null が返る。
     *
     * @param user
     * @returns {*}
     */
    getMemberByUser: function(user) {
        if(!user) {
            return null;
        }

        return this.find(m => {
            return m && (_.isString(user) || _.isNumber(user) ?
                    m.getUserID().toString() == user.toString() :
                    m.getUserID() == user.id);
        });
    },

    getMembersByUserId: function(ids) {
        const idStrings = _.map(ids, id => id.toString());
        return this.filter(
            m => _.contains(idStrings, m.getUser().id.toString()));
    },

    findByQuery: function(query, options) {
        const exact = options && options.exact == true;
        return this.filter(function(model){
            if(model.isSuspended()) {
                return false;
            }

            if(query == '') {
                return true;
            }
            else if(exact) {
                return model.getUser().getName().toLowerCase() == query;
            } else {
                return _.some(model.getUser().getName().split(/\s+/),
                    function(nwords) {
                        return nwords.toLowerCase().indexOf(
                                query.toLowerCase()
                            ) == 0;
                    });
            }
        });
    },
});



// WEBPACK FOOTER //
// ./common/domain/collection/member.js